import React, { useState, useEffect } from 'react';
import style from './TTSSetting.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import SwitchBox from '../../../../components/box/SwitchBox';

const TTSSetting = () => {
    const [ttsEnabled, setTtsEnabled] = useState(false);

    // 초기값 로드
    useEffect(() => {
        const saved = localStorage.getItem('ttsEnabled');
        if (saved !== null) {
            setTtsEnabled(saved === 'true');
        }
    }, []);

    const handleTtsToggle = (value) => {
        setTtsEnabled(value);
        localStorage.setItem('ttsEnabled', value.toString());

        // 네이티브에 전달
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'TTS_TOGGLE',
                enabled: value
            }));
        }
    };

    return (
        <>
            <HeadSub title="음성 읽기 설정" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">
                    <div className={style['tts-box']}>
                        <div className={style['top']}>
                            <strong>음성 읽기</strong>
                            <SwitchBox
                                toggles={ttsEnabled}
                                status={handleTtsToggle}
                            />
                        </div>
                        <div className={style['mid']}>
                            <span>화면의 텍스트를 길게 누르면 음성으로 읽어줍니다.</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TTSSetting;